import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** Page theme (color mode) segmented control, bound to the board design context. */
export const ShareBoardDesignPageThemeRow = memo(() => {
  const { colorModeOptions, selectedColorModeOption, handleSelectColorMode } = useShareBoardDesign();

  return (
    <SegmentedControlRow
      data-testid="SHARE_BOARD_DESIGN_COLOR_MODE_ROW"
      label="Page theme"
      onSelect={handleSelectColorMode}
      options={colorModeOptions}
      selectedOption={selectedColorModeOption}
    />
  );
});

ShareBoardDesignPageThemeRow.displayName = 'ShareBoardDesignPageThemeRow';
